export enum AuthErrorCode {
  InvalidVerificationCode = 'invalidVerificationCode',
  VerificationCodeSendFailed = 'verificationCodeSendFailed',
  RateLimitExceeded = 'rateLimitExceeded',
  RecaptchaFailed = 'recaptchaFailed',
  GetUserFailed = 'getUserFailed',
}

export interface LoginRequest {
  phoneNumber: string
  recaptchaToken: string
  isHumanCaptcha?: boolean
}

export interface LoginResponse {
  success: boolean
  requiresHumanCaptcha: boolean
  humanCaptchaSiteKey?: string
  errorMessage?: string
  errorCode?: AuthErrorCode
}

export interface LoginVerifyRequest {
  phoneNumber: string
  verificationCode: string
  recaptchaToken: string
  isHumanCaptcha?: boolean
}

export interface LoginVerifyResponse {
  success: boolean
  token: string
  requiresHumanCaptcha: boolean
  humanCaptchaSiteKey?: string
  errorMessage?: string
  errorCode?: AuthErrorCode
}

export interface MemberProfile {
  id: string
  firstName: string
  lastName: string
  phoneNumber: string
  isAffiliatePartner: boolean
  referralCode: string
  imageUrl: string | null
}
